module.exports = __webpack_public_path__ + "images/referenzen/werbespot/momodo_chameleon.jpg";